import { Alert, Box, Button, Divider, IconButton, ITheme, TextField, Typography, useTheme } from '@mui/material'
import React, { useState } from 'react'
import AddIcon from '@mui/icons-material/Add';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Utilities } from '../../utility/utils';
import ApiKeyItem from './ApiKeyItem';

const ApiKeyHandler: React.FC = () => {
    const theme = useTheme() as ITheme;
    const [keys, setKeys] = useState<{key: string, validity: Date} []>([]);

    const onCreateNew = () => {
        const updateKeys = [...keys];
        updateKeys.unshift({key: Utilities.generateKey(), validity: new Date(Date.now() + 1000*3600*24*365)});
        setKeys(updateKeys);
    }
    return (
        <Box display={"flex"} flexDirection={"column"} flexGrow={1} gap={"10px"}>
            <Box display={"flex"} justifyContent={'space-between'} alignItems={"center"}>
                <Typography variant={"h3"}>API Keys</Typography>
                <Button variant='contained' startIcon={<AddIcon />} onClick={onCreateNew}>Create new key</Button>
            </Box>
            <Divider />
            <Box display={"flex"} flexDirection={"column"} gap={"10px"}>
                <Alert variant='standard' severity='warning'>Use API key to connect your internal platform to our portfolio system and profide your customers access to your investments. The API key is private and you must not communicate it to any untrusted third party.</Alert>
                {keys.length === 0 ?
                <Box display={"flex"} justifyContent={"center"} padding={"20px"}>
                    <Typography color={theme.palette.grey[800]}>You have created no keys, click on &quot;Create new key&quot; to create your first API key</Typography>
                </Box>
                :
                <>
                {keys.map(k => (<ApiKeyItem key={`key-${k.key}`} keyValue={k}/>))}
                </>
                } 
            </Box>
            <Divider />
            <Typography variant='h4' fontWeight={"bold"}>Usage</Typography>
            <Box display={"flex"} flexDirection={"row"} borderRadius={"20px"} bgcolor={theme.palette.primary.main} gap={"10px"} padding={"20px"}>
                <Box display={"flex"} flexDirection={"column"} flexGrow={1} gap={"10px"} justifyContent={"center"}>
                    <Typography fontWeight={"bold"}>Developer quickstart</Typography>
                    <Typography>Set up your environment and make you<br />first API request in minutes !</Typography>
                </Box>
                <Divider orientation='vertical' />
                <Box display={"flex"} flexDirection={"column"} flexGrow={2} justifyContent={"center"}>
                    <pre>
                        <span style={{ color: theme.palette.leo.color17}}>GET </span><span style={{ color: theme.palette.leo.color14}}>https://d164neu2tel0dv.cloudfront.net/api/customer/portfolios</span><br />
                        <span style={{ color: theme.palette.leo.color9}}>Content-Type: application/json</span><br />
                        <span style={{ color: theme.palette.leo.color9}}>Authorization: Bearer </span><span style={{ color: theme.palette.leo.color3}}>$API_KEY</span>
                    </pre>
                </Box>
            </Box>
        </Box>
    )
}

export default ApiKeyHandler